import { z } from "zod";

export const sweepsEntitySchema = z.object({
  user_id: z.string().min(1, "User ID is required"),
  processing_account_id: z.string().min(1, "Processing account ID is required"),
  external_identifier: z.object({
    linked_account_id: z.string().min(1),
    counterparty_id: z.string().min(1),
  }),
  sweeps_cadence_interval: z.number().int(),
  active_sweep: z.boolean(),
  authorization: z.any(), //.object({}).nullable(),
  auth_date: z.any(),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.any(), //string().datetime({ offset: true }).nullable(),
});

export const sweepsPayloadSchema = z.object({
  linked_account_id: z.string().min(1, "Linked account ID is required"),
  sweeps_cadence_interval: z.number().int().min(1).optional(),
  active_sweep: z.boolean().optional(),
  authorization: z.string().nullable().optional(),
  auth_date: z.string().datetime().optional(),
  emails: z.array(z.string().email()).optional(),
});

export const sweepsEntityResponseSchema = z.object({
  data: sweepsEntitySchema,
  response_code: z.number().int().positive(),
  response_message: z.string(),
});

export const SweepReportSchema = z.object({
  sweep_id: z.string(),
  sweep_total: z.number().positive(),
  invoice_number: z.string(),
  invoice_status: z.string(),
  invoice_to: z.string(),
  delivery_email: z.string().email(),
  is_completed: z.boolean(),
  transaction_date: z.string().datetime({ offset: true }).nullable(),
  completed_on_date: z.string().datetime({ offset: true }).nullable(),
  initiated_on_date: z.string().datetime({ offset: true }),
  payment_returned_date: z.string().datetime({ offset: true }).nullable(),
  invoice_total: z.number(),
  fee_total: z.number().nullable(),
  transaction_type: z.string(),
  debit_credit: z.string(),
  net_total: z.number(),
  reference_number: z.string().nullable(),
  external_link: z.string().nullable(),
});

export const SweepSchema = z.object({
  sweep_id: z.string(),
  sweep_total: z.number().positive(),
  is_completed: z.boolean(),
  completed_on_date: z.string().datetime({ offset: true }).nullable(),
  initiated_on_date: z.string().datetime({ offset: true }),
  invoice_total: z.number(),
  fee_total: z.number().nullable(),
  net_total: z.number(),
  report: z.array(SweepReportSchema),
});

export const SweepListResponseSchema = z.object({
  data: z.array(SweepSchema),
  response_code: z.number().int().positive(),
  response_message: z.string(),
});

export type SweepsEntity = z.infer<typeof sweepsEntitySchema>;
export type SweepsEntityResponse = z.infer<typeof sweepsEntityResponseSchema>;
export type SweepsPayload = z.infer<typeof sweepsPayloadSchema>;
export type SweepReport = z.infer<typeof SweepReportSchema>;
export type Sweep = z.infer<typeof SweepSchema>;
export type SweepListResponse = z.infer<typeof SweepListResponseSchema>;
